import { AppErrorType } from './app-error-type.model';

export const DEFAULT_ERROR_MESSAGES: Record<AppErrorType, { title: string; message: string; retryable: boolean }> = {
    validation: {
        title: 'errors.default.validation.title',
        message: 'errors.default.validation.message',
        retryable: false
    },
    network: {
        title: 'errors.default.network.title',
        message: 'errors.default.network.message',
        retryable: true
    },
    timeout: {
        title: 'errors.default.timeout.title',
        message: 'errors.default.timeout.message',
        retryable: true
    },
    authentication: {
        title: 'errors.default.authentication.title',
        message: 'errors.default.authentication.message',
        retryable: false
    },
    authorization: {
        title: 'errors.default.authorization.title',
        message: 'errors.default.authorization.message',
        retryable: false
    },
    service: {
        title: 'errors.default.service.title',
        message: 'errors.default.service.message',
        retryable: true
    },
    notFound: {
        title: 'errors.default.notFound.title',
        message: 'errors.default.notFound.message',
        retryable: false
    },
    unknown: {
        title: 'errors.default.unknown.title',
        message: 'errors.default.unknown.message',
        retryable: true
    }
};

export const AUTH_ERROR_MESSAGES = {
    invalidCredentials: 'errors.auth.invalidCredentials',
    unauthorizedLogin: 'errors.auth.unauthorizedLogin',
    invalidOtp: 'errors.auth.invalidOtp',
    expiredOtp: 'errors.auth.expiredOtp',
    expiredSession: 'errors.auth.expiredSession',
    lockedAccount: 'errors.auth.lockedAccount',
    recoveryFailed: 'errors.auth.recoveryFailed',
    resetFailed: 'errors.auth.resetFailed',
    resetRequirementsTitle: 'errors.auth.resetRequirementsTitle',
    resetRequirementsMessage: 'errors.auth.resetRequirementsMessage'
} as const;

export const RESET_CREDENTIAL_POLICY = [
    'errors.auth.resetRequirements.minLength',
    'errors.auth.resetRequirements.lowercase',
    'errors.auth.resetRequirements.uppercase',
    'errors.auth.resetRequirements.number',
    'errors.auth.resetRequirements.symbol',
    'errors.auth.resetRequirements.noUsername',
    'errors.auth.resetRequirements.noFirstOrLastName',
    'errors.auth.resetRequirements.noRecentCredentials',
    'errors.auth.resetRequirements.minimumAge'
] as const;
